import { jsx as _jsx } from "react/jsx-runtime";
import TutorPage from "./TutorPage";
export default function FractionsPage() {
    return _jsx(TutorPage, { initialTopic: "Fractions", lockTopic: true });
}
